import { Container, Button } from '@material-ui/core';
import { Card, Col } from 'react-bootstrap';
import React from 'react';
import { Link } from 'react-router-dom';
import withTranslations from '../utils/HighOrderComponent';
import AuthenticationService from './AuthenticationService';
import { mdulsAdminEmail } from '../constants/globals';
import { mailTrigger } from '../utils';

const UnauthorizedAccess = (props) => {
  const { t, gt } = props || {},
    { cardTitle, Email } = t || {};

  const handleMailTrigger = () => {
    mailTrigger({
      recipient: mdulsAdminEmail,
      subject: Email.subject,
      body: Email.body,
    });
  };

  return (
    <Container className="unauthorized-access-message">
      <Col md={7} className="m-auto">
        <Card>
          <Card.Header>
            <Card.Title as="h5">
              {cardTitle}{' '}
              {
                <Link to="#" onClick={handleMailTrigger}>
                  <u>{mdulsAdminEmail}</u>
                </Link>
              }
            </Card.Title>
          </Card.Header>
          <Card.Body className="text-center">
            <Button
              variant="contained"
              color="primary"
              className="mt-4"
              type="submit"
              onClick={() => AuthenticationService.logout()}
            >
              <Link className="link-without-decoration" to="#">
                {gt.Button.toLandingPage}
              </Link>
            </Button>
          </Card.Body>
        </Card>
      </Col>
    </Container>
  );
};

export default withTranslations(UnauthorizedAccess, 'UnauthorizedAccess');
